<template>
    <div class="af-searchbar-container">
        <div class="af-searchbar-inner-container afu-mb-6">
            <div class="afu-mb-0"> 
                <div class="af-keyword-search afu-block afu-border afu-box-border afu-border-solid afu-appearance-none afu-border-b-0 afu-transition afu-duration-150 afu-ease-in-out afu-text-black afu-border-inputBorder-400 focus:afu-border-inputBorder-600 afu-bg-white afu-px-3 afu-py-4 afu-h-full">
                    <div class="label-wrapper afu-mb-0 af-text--5xl afu-text-secondary afu-font-semibold">
                        <span class="afu-uppercase afu-font-bold afu-tracking-widest">Keywords</span>
                    </div>
                    <input
                        class="search-keywork-input afu-border-none afu-w-full focus:afu-outline-none afu-placeholder-custom afu-text-xl afu-p-0 afu-pt-1"
                        name="search-keywork-input"
                        v-model="keyword"
                        :placeholder="$t('label.search_keyword')"
                    >
                </div>
            </div>
            <div class="afu-mb-0">
                <div class="searchbar-height">
                    <ClassificationSelecter
                        :init-classifications="classifications"
                        :close-dropdown="closeClassificationDropdown"
                        @updateClassification="searchClassification"
                    />
                </div>
            </div>
            <div class="afu-mb-0">
                <div class="af-location-search afu-relative afu-block afu-border afu-box-border afu-border-solid afu-appearance-none afu-border-t-0 afu-transition afu-duration-150 afu-ease-in-out afu-text-black afu-border-inputBorder-400 focus:afu-border-inputBorder-600 afu-bg-white afu-px-3 afu-py-4 afu-h-full">
                    <div class="label-wrapper afu-mb-0 af-text--5xl afu-text-secondary afu-font-semibold">
                        <span class="afu-font-bold afu-tracking-widest afu-uppercase">Location</span>
                    </div>
                    <C1Typeahead
                        v-model="location.label"
                        class="searchbar-typeahead w-100 afu-border-none"
                        naked
                        size="naked"
                        :is-busy="spinner.location"
                        :options="locationOptions"
                        :no-icon="true"
                        :search-min-length="2"
                        label-key="label"
                        value-key="id"
                        filter-by="label"
                        :placeholder="$t('label.select_location')"
                        @search="searchLocations"
                        @hit="onLocationSelect"
                    >
                        <template
                            slot="noResults"
                        >
                            <div>
                                No matching locations found.
                            </div>
                        </template>
                    </C1Typeahead>
                </div>
            </div>
            <div class="afu-flex afu-flex-wrap afu-justify-between afu-mt-4">
                <div class="afu-pr-1 afu-w-1/2 afu-box-border">
                    <C1Button
                        type="button"
                        variant="neutral"
                        class="af-search-filters-btn afu-w-full"
                        @click.stop.prevent="handleFilters()"
                    >
                        <FontAwesomeIcon
                            size="sm"
                            :icon="['far', 'sliders-h']"
                            class="afu-text-secondary afu-mr-2"
                        />
                        {{ $t('label.filters') }}
                    </C1Button>
                </div>
                <div class="afu-pl-1 afu-w-1/2 afu-box-border">
                    <C1Button
                        type="button"
                        variant="primary"
                        class="afu-w-full"
                        @click.stop.prevent="handleSearch()"
                    >
                        <span>{{ $t('label.search_jobs') }}</span>
                    </C1Button>
                </div>
            </div>
        </div>
        <Transition name="slide">
            <C1Modal
                v-if="isFilterModalOpen"
                modal-content-class="afu-p-4 md:afu-p-8 md:afu-pt-6 afu-pb-15 md:afu-pb-8"
                size="full"
                @close="closeModal"
            >
                <template v-slot:header>
                    <div class="afu-flex afu-items-center afu-justify-between afu-mb-4">
                        <div class="afu-flex afu-items-center afu-text-2xl afu-text-secondary afu-font-semibold">
                            <FontAwesomeIcon
                                size="sm"
                                :icon="['far', 'sliders-h']"
                                class="afu-text-secondary afu-mr-3"
                            /> Filters
                        </div>
                        <a
                            href="#"
                            class="afu-text-neutral-dark afu-text-2xl afu-mr-3"
                            @click.stop.prevent="closeModal()"
                        >
                            <FontAwesomeIcon :icon="['fal', 'times']" />
                        </a>
                    </div>
                </template>
                <template v-slot:body>
                    <SearchResultSidebar
                        @search="handleSearch"
                    />
                </template>
                <template v-slot:footer>
                    <div class="modal-footer-showjobs afu-w-full afu-bg-white afu-fixed afu-bottom-0 afu-left-0 afu-p-4 afu-box-border">
                        <C1Button
                            type="button"
                            variant="primary"
                            block
                            @click.stop.prevent="closeModal()"
                        >
                            <span>Show jobs</span>
                        </C1Button>
                    </div>
                </template>
            </C1Modal>
        </Transition>
    </div>
</template>

<script>
    import C1Modal from '@/components/C1Components/C1Modal';
    import SearchBarMixin from '@/apps/search/001/components/Mixins/SearchBarMixin';
    import SearchResultSidebar from './Filters/SearchResultSidebar';

    export default {
        name: 'SearchBarMobile',

        mixins: [SearchBarMixin],

        components: {
            C1Modal,
            SearchResultSidebar,
        },


        data() {
            return {
                isFilterModalOpen: false,
                locationOptions: [],
                searchResults: [],
                searchQuery: {
                    location: '',
                    classification: [],
                    keyword: '',
                },
                spinner: {
                    location: false,
                },
            };
        },

        methods: {    
            handleFilters() {
                this.isFilterModalOpen = true;
            },

            closeModal() {
                this.isFilterModalOpen = false;
            },
        },
    };
</script>
<style lang="scss" scoped>
    .af-location-search {
        .searchbar-typeahead {
            &::v-deep {
                .af-input {
                    border: 0 !important;
                    padding: 0 !important;
                    font-size: 14px;
                    line-height: inherit;
                    height: auto;
                }
            }
        }
    }

    .slide-leave-active,
    .slide-enter-active {
        transition: 300ms;
    }

    .slide-enter {
        transform: translate(-100%, 0);
    }

    .slide-leave-to {
        transform: translate(-100%, 0);
    }
</style>
